
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toast, ToastContainer, Button } from 'react-bootstrap';

interface UpdateToastProps {
  show: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

const UpdateToast: React.FC<UpdateToastProps> = ({ show, onUpdate, onDismiss }) => {
  const { t } = useTranslation();
  return (
    <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 9999 }}>
      <Toast show={show} onClose={onDismiss} bg="info">
        <Toast.Header closeButton={true}>
          <strong className="me-auto">{t('updateToast.heading')}</strong>
        </Toast.Header>
        <Toast.Body className="text-white">
          {t('updateToast.message')}
          <div className="mt-2 pt-2 border-top d-flex gap-2">
            <Button variant="light" size="sm" onClick={onUpdate}>
              {t('updateToast.updateNow')}
            </Button>
            <Button variant="outline-light" size="sm" onClick={onDismiss}>
              {t('updateToast.later')}
            </Button>
          </div>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default UpdateToast;
